export default __webpack_public_path__ + "static/media/logosN5.103ede26.jpg";